export default "__VITE_ASSET__MOI9fBBS__"